var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineLogo = function SvgLineLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.464.809a2.06 2.06 0 0 1 2.707.483l.119.172L6.82 5.52a2.06 2.06 0 0 1-.483 2.707l-.172.12a2.06 2.06 0 0 1-2.826-.657L.809 3.635A2.06 2.06 0 0 1 1.464.809"
  })));
};
export default SvgLineLogo;